/*
Documentation

this page holds all the routes for the auth layout

*/

import Forgot from '../pages/Forgot';
import Register from '../pages/Register';
import Login from '../pages/Login';
import Logout from '../pages/Logout';

export default [

    {
        path: "/forgot",
        component: Forgot,
    },
    {
        path: "/register",
        component: Register,
    },
    {
        path: "/login",
        component: Login,
    },
    {
        path: "/logout",
        component: Logout,
    },
    {
        path: "/",
        component: Login,
    },
  
]